import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(pageTitleStyles, {
    ...pageTitleStyles,
    titleText: {
        variant: "h2",
        size: 24,
        color: "text.main",
        fontFamily: "NeuronBold",
        css: css`
            border-bottom: 0;
            font-size: 24px;
            font-family: "NeuronBold";
            color: ${getColor("text.main")};
            text-transform: capitalize;
            margin-bottom: 0;
            padding-bottom: 0;
        `,
    },
});
